import { base } from './base';

export const opensense = {
  meta: {
    name: 'Opensense'
  },
  ...base
};
